import ApiService from "@/base/api/api.service"

import {
    GET_SEARCH_LIST,
    GET_SEARCH_LIST_PROFILE
} from "@/store/actions.type"

import {
    PUSH_SEARCH_LIST,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_POST_URL,
    GET_PROFILE_URL
} from "@/base/api/config";

const StateKey = 'searchList'

export default {
    async [GET_SEARCH_LIST]({ commit, state }, payload) {
        try {
            const res = await ApiService.get(GET_POST_URL, 
              `list?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}&search=${payload.key}`)
            commit(PUSH_SEARCH_LIST, res.data.posts)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    async [GET_SEARCH_LIST_PROFILE]({ commit, state }, payload) {
        try {
            const res = await ApiService.get(GET_PROFILE_URL, 
              `list?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}&search=${payload.key}`)
            commit(PUSH_SEARCH_LIST, res.data.profiles)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}